import React, {Component} from "react";
import Proptypes from "prop-types";

class ServiceBotSubscription extends Component {
    componentDidMount() {
        (function () {
            var s = document.createElement('script');
            s.src = 'https://js.servicebot.io/embeds/servicebot-billing-settings-embed.js';
            s.async = true;
            s.type = 'text/javascript';
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        })();
    }

    render() {
        window.servicebotSettings = {
            servicebot_id: "OJ7ZpGRwFZ2c", // LIVE & TEST MODE IDs ARE DIFFERENT
            service: "Kasm Disposables",
            email: this.props.email,
            hash: this.props.hash,
            options: {
                behavior: {
                    subscription_portal: {
                        billingCycleAnchor: "now"
                    }
                },
                card: {
                    hideAddress: true,
                    hideCountryPostal: true
                }
            }
        };


        return (
            <div id="servicebot-subscription-portal"></div>
        );
    }
}


ServiceBotSubscription.propTypes = {
    email: Proptypes.string.isRequired,
    hash: Proptypes.string.isRequired
};

export default ServiceBotSubscription


// WEBPACK FOOTER //
// ./src/components/ServiceBot/Subscription/Subscription.js